"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var js_brand_1 = require("@giphy/js-brand");
var react_1 = __importDefault(require("react"));
var useRaf_1 = __importDefault(require("react-use/lib/useRaf"));
var Bar = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n    height: ", "px;\n    position: absolute;\n    width: 5px;\n    bottom: 0;\n    left: 0;\n    opacity: 0.95;\n"], ["\n    background: ", ";\n    height: ", "px;\n    position: absolute;\n    width: 5px;\n    bottom: 0;\n    left: 0;\n    opacity: 0.95;\n"])), js_brand_1.giphyWhite, function (props) { return props.barHeight; });
var ProgressBar = function (_a) {
    var videoEl = _a.videoEl;
    (0, useRaf_1.default)(2147483647, 100);
    var time = (videoEl === null || videoEl === void 0 ? void 0 : videoEl.currentTime) || 0;
    var duration = (videoEl === null || videoEl === void 0 ? void 0 : videoEl.duration) || 0;
    var val = time / duration;
    var percentage = Math.round(val * 100);
    var barHeight = 5;
    if ((videoEl === null || videoEl === void 0 ? void 0 : videoEl.height) < 200) {
        barHeight = 3;
    }
    else if ((videoEl === null || videoEl === void 0 ? void 0 : videoEl.height) < 300) {
        barHeight = 4;
    }
    percentage = duration < 10 && percentage > 98 ? 100 : percentage;
    return react_1.default.createElement(Bar, { style: { width: "".concat(percentage, "%") }, barHeight: barHeight, className: "hide-in-percy" });
};
exports.default = ProgressBar;
var templateObject_1;
//# sourceMappingURL=progress-bar.js.map